export default "__VITE_ASSET__CdRDxid8__"